/**
 * Odeslání formuláře
 * @param  {Object} e událost
 * @return {void}
 */
module.exports = function (e) {

  e.preventDefault();
  var success = true;
  var dateRegEx = /^(0?[1-9]|[12][0-9]|3[01])[.](0?[1-9]|1[012])[.]\d{4}$/
  var from = $('[name=destination_from]');
  var to = $('[name=destination_to]');
  var dateTo = $('[name=departure_date]')
  var dateFrom = $('[name=arrival_date]')
  var fromLocationType = from.data().locationType;
  var toLocationType = to.data().locationType;

  if(typeof fromLocationType === "undefined") {
    fromLocationType = 'CITY'
  }

  if(typeof toLocationType === "undefined") {
    toLocationType = 'CITY'
  }

  if (from.val().length === 0 || from.data().noMatch) {
    success = false;
    if (!from.parent().hasClass('invalid'))
      createAlert(from.parent());
  } else
    removeAlert(from.parent());


  if (to.val().length === 0 || to.data().noMatch) {
    success = false;
    if (!to.parent().hasClass('invalid'))
      createAlert(to.parent());
  } else
    removeAlert(to.parent());


  if (dateTo.val().match(dateRegEx) === null) {
    success = false;
    if (!dateTo.parent().hasClass('invalid'))
      createAlert(dateTo.parent());
  } else
    removeAlert(dateTo.parent());

  // if (dateFrom.val().match(dateRegEx) === null) {
  //   success = false;
  //   if (!dateFrom.parent().hasClass('invalid'))
  //     createAlert(dateFrom.parent());
  // } else
  //   removeAlert(dateFrom.parent());



  if(window.location.host !== 'jizdenky.regiojet.cz') { //pokud nejsme na starem pruchodu, validace LocationType parametru
    if (!fromLocationType) {
      success = false;
      if (!from.parent().hasClass('invalid'))
        createAlert(from.parent());
    } else
      removeAlert(from.parent());


    if (!toLocationType) {
      success = false;
      if (!to.parent().hasClass('invalid'))
        createAlert(to.parent());
    } else
      removeAlert(to.parent());

  }



  if (success) {
    var context = $(this).parent(); // element na kterém byla komponenta incializována
    console.log(context);

    var routesStorage = require('./routes-storage')(context);
    var diacritics = require('../../utils/remove-diacritics.js');
    var link = context.data('opts').action || context.data('opts').urls.submit; // url pro odeslání
    console.log(link);
    var departure = $('[name=departure_date]').val().split('.');
    var arrival = $('[name=arrival_date]').val().split('.');
    routesStorage.saveRoute(
      $('[name=destination_from]').val(),
      $('[name=destination_to]').val(),
      $('[name=destination_from_id]').val(),
      $('[name=destination_to_id]').val(),
      fromLocationType,
      toLocationType
    );

    //####### NEW REGIOJET URL ->> aplikace ACTUM ##########################################################################################

    /* if ($('body').hasClass('homepage-new') == true) */
    /* if(window.location.hostname.split('.')[1] === 'studentagency') */
    if ($('body').hasClass('homepage-new') == true || window.location.hostname.split('.')[1] === 'studentagency' || $('#ybus-form-map').length !== 0 || window.location.hostname.split('.')[0] === 'qa-olymp9' || window.location.hostname.split('.')[0] === 'studentagency-cz-qa' || window.location.hostname.split('.')[0] === 'olymp9' || window.location.hostname.split('.')[0] === 'regiojet') {//pouze pokud jsme na nove adrese
    //link = 'https://dpl-qa-ybus-nodejs.sa.cz/';

      var temp = location.host.split('.').reverse();

      var root_domain = temp[0];
      var domain_name = temp[0]; //promenna pro .mutace, protoze se nize com meni na en a vlozila by se do url v linku

      console.log(root_domain);
      if (root_domain === 'com')
        root_domain = 'en';

      if (root_domain === 'cz')
        root_domain = 'cs'


      if (root_domain === 'eu' && window.location.pathname === '/de/') {
        root_domain = 'de';
        domain_name = 'de';
      } else if (root_domain === 'eu') {
        root_domain = 'en';
        domain_name = 'com';
      }

      link = 'https://shop.regiojet.';
      if(window.location.hostname.split('.')[0] === 'regiojet-cz-qa') link = 'https://dpl-qa-ybus-nodejs.sa.';
      link += `${domain_name}/?locale=${root_domain}`;
      link += `&departureDate=${departure[2]}-${departure[1]}-${departure[0]}`;
      link += `&fromLocationId=${diacritics($('#destination_from_id').val().length === 0 ? $('#destination_from').val() : $('#destination_from_id').val())}`;
      link += `&toLocationId=${diacritics($('#destination_to_id').val().length === 0 ? $('#destination_to').val() : $('#destination_to_id').val())}`;
      if(dateFrom.val().match(dateRegEx) != null)
        if (arrival[2] && arrival[1] && arrival[0])
          link += `&returnDepartureDate=${arrival[2]}-${arrival[1]}-${arrival[0]}`;

      ;


      if (fromLocationType === undefined)
        link += '&fromLocationType=CITY';
      else
        link += `&fromLocationType=${fromLocationType}`;
      ;

      if (toLocationType === undefined)
        link += '&toLocationType=CITY';
      else
        link += `&toLocationType=${toLocationType}`;
      ;


      $('#ybus-tariffs-block').find('.tariff-block:visible').find('select').each(function () {
        link += `&tariffs=${$(this).val()}`;
      });
      $('#destination_from').click(function (e) {
        e.preventDefault();
      });
      $('#destination_to').click(function (e) {
        e.preventDefault();
      });

      if (window.location.hostname.split('.')[1] === 'studentagency')
        switch (window.location.hostname.split('.')[2]) {
        case 'cz':
          link += '&affiliate=satravelcz18042019&utm_source=referral&utm_medium=odkaz&utm_campaign=formular';
          //original started with ?, but this throw error
          break;
        case 'sk':
          link += '&affiliate=satravelsk18042019&utm_source=referral&utm_medium=odkaz&utm_campaign=formular';
          //original started with ?, but this throw error
          break;
        default:
          link = link;
        }


    }
    //####### NEW REGIOJET URL ->> aplikace ACTUM ##########################################################################################

    //####### OLD REGIOJET URL ->> jizdenky.regiojet.cz ##########################################################################################
    else {
      // pokud link nekonci '/', pridame
      if (!(link.slice(-1) === '/'))
        link += '/';

      window.mobileAndTabletcheck = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      };

      //Link sa poskladá zo skrytých inputov, ktoré reprezentujú idčka vybratých miest
      link += `from/${diacritics($('#destination_from_id').val().length === 0 ? $('#destination_from').val() : $('#destination_from_id').val())}`;
      link += `/to/${diacritics($('#destination_to_id').val().length === 0 ? $('#destination_to').val() : $('#destination_to_id').val())}`;

      $('#ybus-tariffs-block').find('.tariff-block:visible').find('select').each(function () {
        if (window.mobileAndTabletcheck())
          link += `/tariff/${$(this).val()}`;
        else
          link += `/tarif/${$(this).val()}`;
        ;
      });

      link += `/departure/${departure[2]}${departure[1]}${departure[0]}`;
      link += `/retdep/${arrival[2]}${arrival[1]}${arrival[0]}`;

      if ($('[name=trip_type]:checked').val() === 'round_trip_ybus')
        link += '/return/true';
      else
        link += '/return/false';

      if ($('[name=tip]').is(':checked'))
        link += '/credit/true';
      // WEB-505 - úprava linku pro SA.cz + SA.sk pro rozliseni SA TRAVEL , pro en, de zustava stejny link
      if (window.location.hostname.split('.')[1] === 'studentagency')
        switch (window.location.hostname.split('.')[2]) {
        case 'cz':
          link += '?affiliate=satravelcz18042019&utm_source=referral&utm_medium=odkaz&utm_campaign=formular';
          break;
        case 'sk':
          link += '?affiliate=satravelsk18042019&utm_source=referral&utm_medium=odkaz&utm_campaign=formular';
          break;
        default:
          link = link;
        }

    }
    //####### KONEC - OLD REGIOJET URL ->> jizdenky.regiojet.cz ##########################################################################################

    console.log(context.data('opts'));
    console.log('dataFrom', from);
    console.log(link);
    window.location = link;
  }

  // vytvori chybovou hlasku (text a elementy)
  function createAlert(el) {
    success = false;

    el.addClass('invalid');

    // nefunguje spolehilive docasne deaktivuji
    //    var alertIcon = $('<div/>', {
    //      'class': 'alert-icon'
    //    }).appendTo(el);
    //
    //    var alertMsgs = $('<div/>', {
    //      'class': 'alert-msgs'
    //    }).appendTo(alertIcon);
    //
    //    $('<span/>', {
    //      'text': el.attr('data-required')
    //    }).appendTo(alertMsgs);
  }

  // odstrani chybovou hlasku
  function removeAlert(el) {
    el.removeClass('invalid');
    el.find('.alert-icon').remove();
  }
};
